export default class ValidateError  {
  protected _data: any;

  constructor(protected _message: string, protected _key: string) {
    this._data = { key: this._key };
  }

  get msg(): string {
    return this._message;
  }

  get message(): string {
    return this._message;
  }

  get key(): string {
    return this._message;
  }

  get data() {
    return Object.assign({}, this._data);
  }
}



// WEBPACK FOOTER //
// ./src/utilites/validate/ValidateError.ts